<template>
  <div>
    <component 
      :wareId='wareId'
      :width='width'
      :height='height'
      :is='page'>
    </component>
  </div>
</template>

<script>
import axios from '../../axios.js'
import createSocket from '../../webSocket.js'
import depot1 from './depot1';
import depot2 from './depot2';
export default {
  props:{
    width:Number,
    height:Number,
    wareId:Number
  },
  components:{
    depot1,
    depot2
  },
  data(){
    return{
      page:'depot1'
    }
  },
  created(){
    this.setPage()
  },
  methods:{
    setPage(){
      const user =JSON.parse(localStorage.getItem('user'));
      if(user.username=='whzsk'){
        this.page=depot1;
      }else{
        this.page=depot2;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 
</style>
